import React, { Fragment, useState, useEffect, useRef, useCallback } from "react";
import { useForm } from "react-hook-form";
import Spinner from "../plugins/Spinner";
import useAPI from "../../hooks/useAPI";
import Header from "../layout/Header";
import { Tooltip } from 'react-tooltip'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Avvvatars from "avvvatars-react";
import styled from "styled-components";
import Modal from "../layout/Modal";
import { useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import { debounce, method } from "lodash"; // Instalar con `npm install lodash`
import logoLogin from "../../imgs/logo-login.png";
import logoDark from "../../imgs/Sending_logo_dark.png";
import { v4 as uuidv4 } from 'uuid';

import { MdCleaningServices, MdGroupAdd, MdViewColumn } from "react-icons/md";
import { FaTable, FaSortDown, FaSortUp, FaEye, FaHeartbeat, FaPlus, FaWhatsapp, FaUserTie } from "react-icons/fa";
import { FaCirclePlus, FaRegFaceLaugh, FaShareFromSquare } from "react-icons/fa6";
import { FaTags, FaSpinner, FaShoppingBasket } from "react-icons/fa";
import { IoIosSettings, IoMdMore, IoMdSend } from "react-icons/io";
import { BsTrash3, BsWhatsapp, BsPersonVcard, BsListStars, BsFillPersonCheckFill, BsPencilFill, BsPlusSquareDotted, BsSearch, BsGear } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import { CgNotes } from "react-icons/cg";
import { TiShoppingCart } from "react-icons/ti";
import {questionToast, sendToast} from "../plugins/toastAll";
import { showToast } from "../plugins/toastBuyPackage";
import { toast, ToastContainer } from "react-toastify";
import { BiSolidLabel } from "react-icons/bi";
import { IoMdClose } from "react-icons/io";

import usePersonsFinder from "../../hooks/usePersonsFinder";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { ImCopy } from "react-icons/im";
import toastt, { Toaster } from "react-hot-toast";
import SendMessage from "./ProspectContent/SendMessage";

import "./ProspectContent/modal.css"
import SendText from "./ProspectContent/SendText";
import MessageList from "./ProspectContent/MessageList";
import QuickAnswerList from "../others/QuickAnswerList";
import ShippingOptions from "../others/ShippingOptions";

import Picker from "emoji-picker-react";
import TextareaSendMessage from "../others/TextareaSendMessage";
import PreviewMediaToSend from "../others/PreviewMediaToSend";
import { upload_s3 } from './UploaderS3';
import AssignConversationMessage from "../others/AssignConversationMessage";
import MessageSendTemplate from "../others/MessageSendTemplate";
import OptionsShippigProspects from "./ProspectContent/OptionsShippingProspects";
import { TfiReload } from "react-icons/tfi";
import { HiAdjustmentsHorizontal } from "react-icons/hi2";
import FilterContacts from "./ProspectContent/FilterContacts";
import ContactInfo from "./ProspectContent/ContactInfo";
import ContactList from "./ProspectContent/ContactList";
import ModeTable from "./ProspectContent/ModeTable";
import Process from "./ProspectContent/Process";
import { resolveInternationalPhone } from "../../utils/phone";
import { PROSPECTS_CSS, ProspectsHeader } from "./ProspectContent/prospectsKit";
import { BOT_LIST_CSS, ConfirmDialog, useFullBleed } from "./BotsContent/Others/BotListKit";

const NEW_STAGE_COLOR = "#64748b";
import { useFillHeight } from "./BotsContent/Others/BotCard";

const colors = [
  { name: 'Rojo', value: '#ef4444' },
  { name: 'Verde', value: '#22c55e' },
  { name: 'Azul', value: '#3b82f6' },
  { name: 'Amarillo', value: '#facc15' },
  { name: 'Púrpura', value: '#a855f7' },
];

const Prospects = () => {
  //# Custoom Hooks
  const { urlAPI_1, urlAPI_2, urlAPI_3, urlSocket, fetchWithAuth } = useAPI();
  const {watch,register,handleSubmit,formState: { errors },reset,setValue} = useForm({
    mode: "all",
    defaultValues: {
      email: "",
    },
    note: "",
    segment: [],
    name: "",
    lastName: "",
    phone: "",
    email: "",
    answerName: "",
    answerContent: "",
    tags:[],
  });

  const formChangeName = useForm();
  const error2 = formChangeName.formState.errors;

  const userId = localStorage.getItem("USER_ID");
  const userLogout = localStorage.getItem("USER_NAME");

  //# Navegacion
  const navigate = useNavigate();
  const [confirmStage, setConfirmStage] = useState(null);
  const closeConfirmStage = useCallback(() => setConfirmStage(null), []);
  const [rootRef, rootHeight] = useFillHeight(0);
  useFullBleed(rootRef);

  //# Estados del Modulo (Modales, Spinner)
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("process");
  const [isDark, setIsDark] = useState(false);
  const [editStage, setEditStage] = useState(false);
  const [idStage, setIdStage] = useState(null);
  const [isColumnDragDisabled, setIsColumnDragDisabled] = useState(false);
  const [validation, setValidation] = useState(false);
  const [fieldsList, setFieldsList] = useState([]);
  const [allLists ,setAllLists] = useState([]);
  const [listOrders, setListOrders] = useState([]);
  const [ordersFilteredInfo, setOrdersFilteredInfo] = useState([]);

  //# Informacion del contacto
   //---------others--------- 
  const [showContactInfo, setShowContactInfo] = useState(false);
  const [isFeelings, setIsFeelings] = useState(false);
  const [dataContactInfo, setDataContactInfo] = useState(null);
  const [addNewSegment, setAddNewSegment] = useState(false);
  const [isDisableSelect, setIsDisableSelect] = useState(true);
  const [contactStage, setContactStage] = useState(null);
  const [listsSelected, setListsSelected] = useState([]);
  
  //# Estados de la data
  const [listStages, setListStages] = useState([]);
  
  //# Estados de variables del modulo
  const [nameStage, setNameStage] = useState("");

  //# Estado para sección de asignar contactos
  const [showContacts, setShowContacts] = useState(false);
  const [stageSelected, setStageSelected] = useState("");

  //#--> Estado para colores
  const [selectedColor, setSelectedColor] = useState(colors[0].value);
 
  // const [persons, setPersons] = useState([]);
  const [tablePersons, setTablePersons] = useState([]);
  const [FieldsNames, setFieldsNames] = useState([]);
  const [emptyContacts, setEmptyContacts] = useState(false);
  
  const [loadingContacts, setLoadingContacts] = useState(false);
  
  const [modalConfig, setModalConfig] = useState(false);
  const [automaticCheck, setAutomaticCheck] = useState(false);
  const [savedStage, setSavedStage] = useState("");
  
  // Plantillas de mensajes
  const [templates, setTemplates] = useState([]);

  const [activeId, setActiveId] = useState(false);
  const [conversation, setConversation] = useState([]);
  const conversationRef = useRef(null);
  const [listMessages, setListMessages] = useState([]);
  const [nameConv, setNameConv] = useState("");

  const [inputStr, setInputStr] = useState("");

  
  const [loadingConv, setLoadingConv] = useState(false)
  const [quicklyAnswers, setQuicklyAnswers] = useState("");
  const [searchQuicklyAnswer, setSearchQuicklyAnswer] = useState([]);
  const [viewAnswer, setViewAnswer] = useState(false);
  const [isMedia, setIsMedia] = useState("");
  const [isMediaAnswer, setIsMediaAnswer] = useState("");
  const [isMediaTypeAnswer, setIsMediaTypeAnswer] = useState("");
  const [idAnswerSelected, setIdAnswerSelected] = useState("");
  const [textDocument, setTextDocument] = useState("");
  const [contenMessage, setContenMessage] = useState("");
  const [msgIA, setMsgIA] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);
  const [selectedEmoji, setSelectedEmoji] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [closeEmojis, setCloseEmojis] = useState(false);
  const [fileType, setFileType] = useState("");
  const [selectedImg, setSelectedImg] = useState(null);
  const [mediaSelected, setMediaSelected] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [documentView, setDocumentView] = useState(null);
  const [timerConectionChat, setTimerConectionChat] = useState("")
  const [infoContact, setInfoContact] = useState("")
  const [infoAsigned, setInfoAsigned] = useState("")
  const [isSendTemplate, setIsSendTemplate] = useState(false);
  const [idTemplate, setIdTemplate] = useState([]);
  const [templateSelected, setTemplateSelected] = useState([]);
  const [messageScheduleDate, setMessageScheduleDate] = useState(null);
  const [isUrlDynamic, setIsUrlDynamic] = useState("");
  const [isUrlDynamic2, setIsUrlDynamic2] = useState("");
  const [isAssignedAgent, setIsAssignedAgent] = useState(false);
  const [modalTransferAgent, setModalTransferAgent] = useState(false);

  const [listPersons, setListPersons] = useState([]);

  const [correspondence, setCorrespondence] = useState([]);
  const [listTags, setListTags] = useState([]);
  
  const inputRef = useRef(null);
  const dataFilesRef = useRef([]);
  const chatEndRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const listUserChatsRef = useRef([])
  const agentAssigned = useRef(true);
  const socketConn = useRef(null);
  const closedByUnmount = useRef(false);

  const code_msg_prospects = "4444444444";


  const roleId = localStorage.getItem("USER_ROLEID");
  const [pageSize, setPageSize] = useState(1000);
  const page_api = useRef(0);
  const listContactsRef = useRef([]);
  const totalPages = useRef(1);
  const searchTerm = useRef("");

  const listsByCompany = useRef([])

  const formSendTemplate = useForm();
  const error1 = formSendTemplate.formState.errors;
  const formPutPerson = useForm();
  const error8 = formPutPerson.formState.errors;
  const formAutomatic = useForm();
  const error9 = formAutomatic.formState.errors;

  const { persons, loading: isLoadingContacts, handleChangeSearch: onSearchPersons, searchQuery, setPersons } = usePersonsFinder({
    pageSize: 300,
  });

  const connectI = () => {
    if (socketConn.current) {
      socketConn.current.close();
    }
    const socketConnAux = new WebSocket(urlSocket);
    socketConnAux.addEventListener("open", () => {
      const payload = { Action: "message", Msg: code_msg_prospects };
      try {
        socketConnAux.send(JSON.stringify(payload));
      } catch (error) {
        console.log("error websockets prospectos", error);
      }
    });

    socketConnAux.onmessage = async function (event) {
      const dataMessIn = JSON.parse(event.data);
      if (dataMessIn.type) {
        if (dataMessIn.action === "new-message") {
          if (conversationRef.current?.phoneNumber) {
            fetch_messages(conversationRef.current.phoneNumber, true);
          }
        } else if (dataMessIn.action === "stage-change") {
          getStages(false);
        } else {
          // fallback: prospect-update genérico
          getStages(false);
          if (conversationRef.current?.phoneNumber) {
            fetch_messages(conversationRef.current.phoneNumber, true);
          }
        }
      } else {
        const msgSend = {
          connectionId: `${event.data}`,
          phone: code_msg_prospects,
          agent: localStorage.getItem("USER_ID"),
          status: true,
        };
        const url = urlAPI_2 + "saveConnection";
        const options = { method: "POST", mode: "cors", body: JSON.stringify(msgSend) };
        await fetchWithAuth(url, options);
      }
    };

    socketConnAux.onclose = function (event) {
      console.log("Cerrando websocket prospectos. Estado: ", event.target.readyState);
      if (!closedByUnmount.current) {
        connectI();
      }
      closedByUnmount.current = false;
    };

    socketConn.current = socketConnAux;
  };

  useEffect(() => {
    getIsDark()

    const fetchData = async () => {
      try {
        await Promise.all([
          // fetchPersonsPaged(),
          getStages(),
          getFields(),
          getAllLists(),
          getOrders(),
          getCompanie(),
          getTemplates(),
          getQuickReply(),
          getCorresp(),
          getTags(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    connectI();

    return () => {
      closedByUnmount.current = true;
      if (socketConn.current) {
        socketConn.current.close();
      }
    };
  }, []);
  
  useEffect(() => {
    setLoadingContacts(isLoadingContacts)
  }, [isLoadingContacts]);

  useEffect(() => {
    scrollToBottom("auto");
  }, [listMessages]);  

  const generateId = (longitud) => {
    let resultado = '';
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const caracteresLongitud = caracteres.length;
    for (let i = 0; i < longitud; i++) {
        resultado += caracteres.charAt(Math.floor(Math.random() * caracteresLongitud));
    }
    return resultado;
  }

  const getCorresp = async () => {
    try {
      const url = urlAPI_2 + "getDataEmail";
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log("list correspondence-------->>", result);
      let data = result.data;
      if(data.length) {
        data = data.filter(v => v.field !== "callingCode")
      }
      setCorrespondence(data);
      if (result.message === "Tu petición no tiene cabecera de autorización") {
        sendToast({type: "info", message: "Tu sesion ha caducado, verifica si alguien mas se ha conectado con tus credenciales"})
        navigate("/");
      }
    } catch (error) {
      console.log(error);
    }
  };

  //#--> Listar las etiquetas
  const getTags = async () => {
    try {
      // setLoading(true);
      const url = urlAPI_1 + `tags`;
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log("Data:::", result);
      if(!result.data) {
        console.log("no hay data");
        setListTags([]);
        // setValidationTags(true);
      } else {
        console.log("si hay lista");
        setListTags(result.data);
        // setValidationTags(false);
      }
      // setLoading(false);
    } catch (error) {
      console.log("error:", error);
      return null;
    }
  }

  // CRUD
  // --> LISTAR ETPAS
  const getStages = async (requiredLoading = true) => {
    try {
      setLoading(requiredLoading);
      const url = urlAPI_3 + `stages/?assigns=${userId}`;
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log('☣☣☣☣☣☣☣ ----> ', result);
      
      if(result.length <= 0) {
        setListStages([]);
        setValidation(true);
      } else {
        setListStages(result);
        setValidation(false);
      }
      setLoading(false);
    } catch (error) {
      console.log("error:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };
  //#--> Crear
  const postStages = async () => {
    try {
      setLoading(true);
      setEditStage(false)

      const dataStage = {
        name: nameStage,
        prospects: [],
        needed: false,
      }

      const url = urlAPI_3 + "stages";
      const options = { method: "POST", mode: "cors", body: JSON.stringify(dataStage)};
      const response = await fetchWithAuth(url, options);
      await getStages();
      
      setNameStage("");
      setLoading(false);
      sendToast({type: "success", message: "Etapa creada con éxito."})
    } catch (error) {
      console.log(error);
    }
  };
  //#--> Actualizar
  const putStages = async (id) => {

    const dataStage = {
      name: nameStage,
      // prospects: [],
      // needed: false,
    }

    try {
      setLoading(true);
      const url = urlAPI_3 + `stages/${id}`;
      const options = { method: "PUT", mode: "cors", body: JSON.stringify(dataStage)};
      const response = await fetchWithAuth(url, options);
      await getStages();
      setNameStage("");
      setEditStage(false);
      setIdStage(null);
      sendToast({type: "success", message: "Etapa actualizada."})
    } catch (error) {
      console.log(error);
    }
  };
  //#--> Eliminar
  const deleteStages = async (id) => {
    try {
      const data = {
        isFetch: true,
        fetch: {
          url: urlAPI_3 + `stages/${id}`,
          options: { 
            method: "DELETE", 
            mode: "cors"
          }
        },
        title: "¿Estas seguro que deseas eliminar esta etapa?",
        text: "No podrás recuperarla.",
        icon: "warning",
        buttons: { success: "Eliminar", cancel: "Cancelar" }
      };
    
      console.log("Datos enviados a questionToast:", data);
      const result = await questionToast(data, setLoading);
      console.log("Result -------->: ", result);

      //#--> Actualización de la tabla
      await getStages()

      //#--> Confirmación de la eliminación
      sendToast({type: "success", message: "Etapa eliminada."})
    } catch (error) {
      console.log(error);
    }
  };
  //#--> Vaciar etapa
  const emptyStage = async (id, name) => {
    const dataStage = {
      name: name,
      prospects: [],
      needed: false,
    }
    console.log('dataStage', dataStage);
    try {
      const data = {
        isFetch: true,
        fetch: {
          url: urlAPI_3 + `stages/${id}`,
          // options: { 
          //   method: "DELETE", 
          //   mode: "cors"
          // },
          options: { 
            method: "PUT", 
            mode: "cors", 
            body: JSON.stringify(dataStage)
          }
        },
        title: "¿Estás seguro que deseas vaciar esta etapa?",
        text: "No podrás recuperarla.",
        icon: "warning",
        buttons: { success: "Vaciar", cancel: "Cancelar" }
      };
    
      console.log("Datos enviados a questionToast:", data);
      const result = await questionToast(data, setLoading);
      console.log("Result -------->: ", result);

      //#--> Actualización de la tabla
      await getStages()

      //#--> Confirmación de la eliminación
      sendToast({type: "success", message: "Etapa vaciada."})
    } catch (error) {
      console.log(error);
    }
  };

  const putProspect = async (data, draggableId) => {
    console.log('---------------------putProspect-----------------------------------');
  
    if (!Array.isArray(data.prospects)) {
      console.error("Error: 'data.prospects' no es un array.");
      return;
    }
  
    console.log('data:', data);
    console.log('draggableId:', draggableId);
  
    // Verificar si el prospecto ya existe en la lista
    if (data.prospects.includes(draggableId)) {
      console.log("El prospecto ya está en la lista. No se realizará la actualización.");
      return;
    }
  
    try {
      // Filtrar y mapear de forma eficiente
      const prospects = data.prospects
        .filter(prospect => prospect !== null)
        .map(prospect => (typeof prospect === 'object' ? prospect._id : prospect))
        .concat(draggableId); // Agregar el nuevo prospecto
  
      console.log('Prospectos actualizados:', prospects);
  
      const dataStage = {
        prospect: draggableId,
        data: {
          ...data,
          prospects
        }
      };
  
      console.log('Datos a enviar:', dataStage);
  
      // Actualización optimista para mejorar UX
      // (Aquí deberías actualizar el estado local antes de hacer la petición)
      // setLocalState(prev => ({ ...prev, prospects })); 
  
      const url = `${urlAPI_3}stagesAddProspect/${data._id}`;
      const options = { method: "PUT", mode: "cors", body: JSON.stringify(dataStage) };
  
      await fetchWithAuth(url, options);
  
      // Refrescar datos de manera eficiente
      // await getStages(false); // false indica que no se requiere un loader
    } catch (error) {
      console.error("Error en putProspect:", error);
    }
  };

  //#--> Obtener Campos adicionales
  const getFields = async () => {
    try {
      const url = urlAPI_2 + "aditionalFields";
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      const res = result.data;
      setFieldsList(res);
    } catch (error) {
      console.log(error);
    }
  };
  //# Obtner todas las listas
  const getAllLists = async () => {
    try {
      const url = `${urlAPI_1}lists`;
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();

      if (result.type === "success") {
        listsByCompany.current = result.data;
      } else {
        listsByCompany.current = [];
      }
    } catch (error) {
      console.error("Error al obtener todas las listas:", error);
      listsByCompany.current = [];
    }
  };
  //#--> Obtener Listas Por Id
  const getLists = async (userId) => {
    setAllLists([]);
    try {
      const list_return = listsByCompany.current
      .filter(element => element.persons)
      .map(element => {
        const personslistSplit = element.persons.split(',');
        const count = personslistSplit.length;
        const inList = personslistSplit.includes(userId);
        
        return {
          _id: element._id,
          company: element.company,
          description: element.description,
          name: element.name,
          created: element.created,
          count,
          inList,
        };
      });
      setAllLists(list_return);
    }catch (error) {
      console.log(error);
    }
  };
  //#--> Optener Orders
  const getOrders = async () => {
    try {
      const url = urlAPI_2 + 'getOrders';
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      if(!result.data) {
        setListOrders([]);
      } else {
        setListOrders(result.data);
      }
    } catch (error) {
      console.log("error:", error);
      return null;
    }
  };

  const realStages = () => listStages.filter((stage) => !stage.new);

  const createStage = async (insertAt = null) => {
    const tempId = `tmp_${Date.now()}`;
    const placeholder = { _id: tempId, name: "Nueva etapa", color: NEW_STAGE_COLOR, prospects: [], count: 0, pending: true };
    const next = [...realStages()];
    next.splice(insertAt === null ? next.length : insertAt, 0, placeholder);
    setListStages(next);
    try {
      const response = await fetchWithAuth(urlAPI_3 + "stages", {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({ name: placeholder.name, color: placeholder.color, prospects: [] }),
      });
      const result = await response.json();
      if (!response.ok || !result?._id) throw new Error(result?.message || "No se pudo crear la etapa.");
      setListStages((stages) => stages.map((stage) => (stage._id === tempId ? { ...stage, _id: result._id, pending: false } : stage)));
      if (insertAt !== null) await saveStagesOrder(next.map((stage) => ({ _id: stage._id === tempId ? result._id : stage._id })));
      sendToast({ type: "success", message: "Etapa creada. Doble clic en el nombre para renombrarla." });
    } catch (error) {
      setListStages((stages) => stages.filter((stage) => stage._id !== tempId));
      sendToast({ type: "error", message: error.message || "No se pudo crear la etapa." });
    }
  };

  const updateStage = async (id, patch) => {
    setListStages((stages) => stages.map((stage) => (stage._id === id ? { ...stage, ...patch } : stage)));
    try {
      const response = await fetchWithAuth(urlAPI_3 + `stages/${id}`, { method: "PUT", mode: "cors", body: JSON.stringify(patch) });
      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result?.message || "No se pudo guardar la etapa.");
      }
    } catch (error) {
      sendToast({ type: "error", message: error.message });
      getStages(false);
    }
  };

  const moveStage = async (id, step) => {
    const ordered = realStages();
    const from = ordered.findIndex((stage) => stage._id === id);
    const to = from + step;
    if (from < 0 || to < 0 || to >= ordered.length) return;
    const [moved] = ordered.splice(from, 1);
    ordered.splice(to, 0, moved);
    setListStages(ordered);
    try {
      await saveStagesOrder(ordered);
    } catch (error) {
      sendToast({ type: "error", message: "No se pudo guardar el orden." });
      getStages(false);
    }
  };

  const removeStage = async (stage) => {
    const count = (stage.prospects || []).filter(Boolean).length;
    if (count > 0) {
      sendToast({ type: "warning", message: `No puedes eliminar: tiene ${count} prospecto${count === 1 ? "" : "s"}. Muévelos primero.` });
      return;
    }
    const snapshot = listStages;
    setListStages((stages) => stages.filter((item) => item._id !== stage._id));
    try {
      const response = await fetchWithAuth(urlAPI_3 + `stages/${stage._id}`, { method: "DELETE", mode: "cors" });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result?.message || "No se pudo eliminar la etapa.");
      sendToast({ type: "success", message: "Etapa eliminada" });
    } catch (error) {
      setListStages(snapshot);
      sendToast({ type: "error", message: error.message });
    }
  };

  const handleStageAction = (stageId, action, value) => {
    const stage = realStages().find((item) => item._id === stageId);
    if (!stage) return;
    const index = realStages().indexOf(stage);
    if (action === "rename") updateStage(stageId, { name: value });
    else if (action === "color") updateStage(stageId, { color: value });
    else if (action === "moveLeft") moveStage(stageId, -1);
    else if (action === "moveRight") moveStage(stageId, 1);
    else if (action === "addLeft") createStage(index);
    else if (action === "addRight") createStage(index + 1);
    else if (action === "delete") removeStage(stage);
    else if (action === "empty") {
      setConfirmStage({
        title: `Vaciar «${stage.name}»`,
        text: "Los prospectos saldrán del tablero. Los contactos no se eliminan.",
        action: "Vaciar etapa",
        run: async () => {
          const snapshot = listStages;
          setListStages((stages) => stages.map((item) => (item._id === stage._id ? { ...item, prospects: [], count: 0 } : item)));
          try {
            const response = await fetchWithAuth(urlAPI_3 + `stages/${stage._id}`, { method: "PUT", mode: "cors", body: JSON.stringify({ prospects: [] }) });
            if (!response.ok) throw new Error("No se pudo vaciar la etapa.");
            sendToast({ type: "success", message: "Etapa vaciada" });
          } catch (error) {
            setListStages(snapshot);
            sendToast({ type: "error", message: error.message });
          }
        },
      });
    }
  };

  const addStage = () => {
    const id = generateId(10)
    const newStage = {
      _id: id,
      name: "",
      count: 0,
      prospects: [],
      needed: false,
      new: true,
    }

    let stages = [...listStages];
    stages.push(newStage)

    setListStages(stages);
  }
  const cancelNewStage = (id) => {
    const filterStages = listStages.filter(v => v._id !== id)
    setListStages(filterStages);
    setNameStage(null);
  }

  const getIsDark = () => {
    const dark = localStorage.getItem("THEME");
    
    setIsDark(dark);
  }
  
  const onDragStart = (start) => {
    const { source } = start;
    if (source.droppableId !== 'droppable-columns') {
      setIsColumnDragDisabled(true);
    }
  };
  const onDragEnd = async (result) => {
    console.log('result en dragEnd:', result);
    console.log('listStages:', listStages);
    setIsColumnDragDisabled(false);
  
    if (!result.destination) return;
    
    const { source, destination, draggableId } = result;
    const sourceIndex = source.index;
    const destinationIndex = destination.index;
    const sourceDroppableId = source.droppableId;
    const destinationDroppableId = destination.droppableId;
  
    // Validar que las columnas solo se muevan dentro de la sección de columnas
    if (sourceDroppableId === 'droppable-columns' && destinationDroppableId !== 'droppable-columns') {
      console.error('No se puede mover una columna a una sección de ítems');
      return;
    }
  
    // Validar que los ítems solo se muevan dentro de sus respectivas columnas
    if (sourceDroppableId !== 'droppable-columns' && destinationDroppableId === 'droppable-columns') {
      console.error('No se puede mover un ítem a una sección de columnas');
      return;
    }

    const newListStages = Array.from(listStages);
  
    // Reordenar columnas
    if (sourceDroppableId === 'droppable-columns' && destinationDroppableId === 'droppable-columns') {
      const [removed] = newListStages.splice(sourceIndex, 1);
      console.log('removed', removed);
      newListStages.splice(destinationIndex, 0, removed);
      setListStages(newListStages);
      console.log('NEW list: ', newListStages);
      
      // ← GUARDAR EL NUEVO ORDEN EN LA BD
      try {
        await saveStagesOrder(newListStages);
      } catch (error) {
        console.error('Error al guardar el orden:', error);
        // Opcional: puedes mostrar un toast/notificación de error
      }
      return;
    }
    console.log('newListrrtttttttt', newListStages);
    console.log('id src', sourceDroppableId);
    console.log('id dest', destinationDroppableId);
    // Mover ítems entre columnas
    const sourceStage = newListStages.find(stage => stage._id === sourceDroppableId);
    const destStage = newListStages.find(stage => stage._id === destinationDroppableId);
    console.log('sour and dest', sourceStage, destStage);
  
    if (!sourceStage || !destStage) {
      console.error('Etapa no encontrada');
      return;
    }
  
    if (sourceDroppableId !== destinationDroppableId) {
      console.log('Este es el iiiiiiiiiiffffffffffff');
      const sourceProspects = Array.from(sourceStage.prospects);
      const destProspects = Array.from(destStage.prospects);
      console.log('⭐⭐⭐⭐', sourceProspects);
      console.log('🤖🤖🤖🤖', destProspects);
      const [removed] = sourceProspects.splice(sourceIndex, 1);
      console.log('removed', removed);
      destProspects.splice(destinationIndex, 0, removed);
      console.log(destProspects);
  
      sourceStage.prospects = sourceProspects;
      destStage.prospects = destProspects;
      console.log('🎁🎁🎁🎁', destStage, draggableId);
    } else {
      console.log('Este es el elseeeeee');
      // Reordenar ítems dentro de la misma columna
      const stage = newListStages.find(stage => stage._id === sourceDroppableId);
      const copiedProspects = Array.from(stage.prospects);
      const [removed] = copiedProspects.splice(sourceIndex, 1);
      copiedProspects.splice(destinationIndex, 0, removed);
  
      stage.prospects = copiedProspects;
    }
    
    setListStages(newListStages);
    putProspect(destStage, draggableId)
  };

  // FUNCIÓN para guardar el orden
  const saveStagesOrder = async (orderedStages) => {
    try {
      const stagesData = orderedStages.map((stage, index) => ({
        _id: stage._id,
        order: index
      }));

      const url = `${urlAPI_3}stages/order`;
      const options = { method: "PUT", mode: "cors", body: JSON.stringify({ stages: stagesData }) };
  
      const response = await fetchWithAuth(url, options);

      const result = await response.json();
      
      if (result.type === 'success') {
        console.log('✅ Orden guardado correctamente');
      } else {
        console.error('❌ Error al guardar:', result.message);
      }
    } catch (error) {
      console.error('❌ Error en saveStagesOrder:', error);
      throw error;
    }
  };

  const handleContactInfo = (item, stage) => {
    setShowContactInfo(true);
    setShowContacts(false)
    setContactStage(stage);
    let lists = []
    if(item.lists && Object.keys(item.lists).length > 0) {
      lists = Object.keys(item.lists).map(key => item.lists[key]);
    }
    const info = {
      ...item,
      lists: lists
    }
    console.log('❤♥❤♥❤♥', info);
    
    setDataContactInfo(info);
    getLists(info._id);
    ordersByUser(info);
    formPutPerson.reset(info, { keepDefaultValues: true });
  }
  const reloadDataContact = async (stageId) => {
    const url = urlAPI_3 + `stages/?assigns=${userId}`;
    const options = { method: "GET", mode: "cors"};
    const response = await fetchWithAuth(url, options);
    const stages = await response.json();

    const findStage = stages.find(v => v._id == stageId)
    if(findStage) {
      if(findStage.prospects.length) {
        const findProspect = findStage.prospects.find(v => v._id == dataContactInfo._id)
        if(findProspect) {
          let lists = []
          if(findProspect.lists && Object.keys(findProspect.lists).length > 0) {
            lists = Object.keys(findProspect.lists).map(key => findProspect.lists[key]);
          }
          const info = {
            ...findProspect,
            lists: lists
          }
          setDataContactInfo(info);
          getLists(info._id);
          formPutPerson.reset(info, { keepDefaultValues: true });
        }
      }
    }
  }

  //#--> Funciones para Informacion del contacto  
  //-----------Listas-------------
  //#--> Afrear usuario a listas
  const addUserToList = async () => {
    setAddNewSegment(false);
    const values = {
      userId: dataContactInfo._id,
      dataSegmentCheck: listsSelected,
    };
    try {
      setLoading(true);
      const url = urlAPI_1 + "addUserToList";
      const options = { method: "POST", mode: "cors", body: JSON.stringify(values)};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      await reloadDataContact(contactStage);
      sendToast(result)
      setIsDisableSelect(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  //Funcion para almacenar las listas asignadas al contacto a crear
  const handleChangeList = data => {
    let idLists = [];
    for(let list of data){idLists.push(list._id)}
    setListsSelected(idLists);
    setDataContactInfo((prev) => ({
      ...prev,
      lists: data
    }))
  };
  
  const ordersByUser = (info) => {
    if (listOrders.length > 0) {
      let phone = resolveInternationalPhone(info.callingCode, info.phone)
      if (phone.startsWith("+")) {
        phone = phone.replace("+", "");
      }

      const ordersFiltered = listOrders.filter(({phoneNumber}) => {
        return phoneNumber == phone; 
      });
      setOrdersFilteredInfo(ordersFiltered);
    }
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'lightblue' : '#fff',
      color: state.isSelected ? '#333' : '#333',
      '&:hover': {
        backgroundColor: 'lightgray',
        color: '#333',
        cursor: 'pointer',
      },
    }),
  };
  const customStylesDark = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#455a64' : '#202c33',
      color: state.isSelected ? 'white' : 'white',
      '&:hover': {
        backgroundColor: '#374954',
        color: 'white',
        cursor: 'pointer',
      },
    }),
  };

  //Funcion que obtiene las plantillas
  const getTemplates = async () => {
    try {
      const url = urlAPI_2 + "templates";
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log("Plantillas========>>", result);
      const listTemplates = result.data;
      if (result.type !== "success") {
        setTemplates([]);
      } else {
        var templatesList = [];
        const isTemplates = listTemplates.filter(tem => {
          if(tem.status === "APROBADA" && tem.isActive === true){
            return templatesList.push(tem)
          }
        })
        console.log('Lista modificada de plantillas=====>', isTemplates)
        setTemplates(isTemplates);
      }
    } catch (error) {
      console.log("error on actualizar", error);
      return null;
    }
  };

  const getCompanie = async () => {
    const resultIdCompany = localStorage.getItem('ID_COMPANY');
    console.log('resultIdCompany: ', resultIdCompany);
    try {
      const url = urlAPI_2 + 'companies/' + resultIdCompany;
      const options = { method: 'GET', mode: 'cors' };
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log('↗companie↗: ', result);
      if (result.code === 0) {
        return null;
      } else if (!result.data) {
        return null;
      } else {
        const data = result.data[0].saveAutomatically
        console.log('↗↗↗↗↗↗↗: ', data);
        if (data && data.isActive) {
          setAutomaticCheck(data.isActive);
          setSavedStage(data.stage)
        } else {
          setSavedStage("")
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const saveAutomatic = async (stage) => {
    console.log('↗↗↗↗↗↗↗↗↗↗: ', stage);
    
    const data = {
      isActive: automaticCheck,
      stage: stage.stage
    }
    console.log('Data a enviar↗: ', data);

    try {
        setLoading(true);
        const url = urlAPI_3 + `automaticSave`;
        const options = { method: "POST", mode: "cors", body: JSON.stringify(data)};
        const response = await fetchWithAuth(url, options);
        const result = await response.json();
        console.log("Result API: automaticSave: ", result);
        setModalConfig(false)
        setLoading(false);
        // sendToast(result)
      } catch (error) {
        console.log(error);
      }
  }

  const fetch_messages = async (phone, isLoad = false) => {
    try {
      scrollToBottom("auto");
      // console.log('👉👉 Despues del scroll ☀☀')
      if (!isLoad) {
        setLoadingConv(true)
      }
      const url = urlAPI_1 + 'fetchMessagesByPhone/' + phone;
      const options = { method: 'GET', mode: 'cors' };
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log('Conversaciopn: ', result.dataRet) 
      setLoadingConv(false)
      if (result.dataRet.dataConversation.length <= 0) {
        setConversation(null);
        setListMessages([]);
        setIsSendTemplate(true)
        return null;
      }
      setConversation(result.dataRet.dataConversation[0]);
      conversationRef.current = result.dataRet.dataConversation[0];
      const userAsigned = result.dataRet.dataConversation[0].userAsign;
      console.log('userAsigned: ', userAsigned)
      let name = ""
      if(userAsigned){
        name = userAsigned
        if (userAsigned.includes("bot")) {
          setIsAssignedAgent((prevMessage) => { return true});
        } else {
          setIsAssignedAgent((prevMessage) => { return false});
        }

      } else {
        name = "Sin signar"
        setIsAssignedAgent((prevMessage) => { return true});
      }
      setInfoAsigned(name)
      setTimerConectionChat(result.dataRet.dataConversation[0].timerConection)
      console.log('Conversacion guardada en el estado 1: ', result.dataRet)
      console.log('Conversacion guardada en el estado 2: ', result.dataRet.dataConversation[0])
      setListMessages(result.dataRet.dataConversation[0].messagesList);
      scrollToBottom("auto");
    } catch (error) {
        console.log('Error al consultar fetch_messages', error);
    } finally {
        setLoadingConv(false);
    }
  }

  const contentStyle = (() => {
    // if (conversation && conversation.timerConection > 24) {
    //   return { display: "flex" };
    // }

    return {
      height: loadingConv || isMedia ? "auto" : "80vh",
      display: "flex",
      // display: loadingConv ? "flex" : "block"
    };
  })();

  // const scrollToBottom = (behavior = "smooth") => {
  //   behavior = "auto";
  //   chatEndRef.current?.scrollIntoView({ behavior });
  // };
  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  };

  const handleRemoveFile = (index) => {
    if (selectedFiles.length == 1) {
      setMediaSelected((mediaSelected) => { return 0 })
      setSelectedImg((selectedImg) => { return "" })
      setTextDocument((textDocument) => { return "" });
      setIsMedia((isMedia) => { return false });
      setFileType((fileType) => { return "" });
      setSelectedFiles((selectedFiles) => { return [] })
      dataFilesRef.current = [];

      setTimeout(function(){
         scrollToBottom("auto");
      }, 200);
    } else {
      const updatedFiles = selectedFiles.filter((_, i) => i !== index);
      setMediaSelected(0)
      setSelectedImg(updatedFiles[0].src);
      setDocumentView(updatedFiles[0])
      setSelectedFiles(updatedFiles);
      dataFilesRef.current = dataFilesRef.current.filter((_, i) => i !== index);
    }
  };

  const onFileInput = async (e, type_file, isPasteImg) => {
    const max_files = 6;
    const conversionFunctions = {
      image: convertBase64,
      video: async (file) => URL.createObjectURL(file),
      document: convertDocumentBase64,
    };

    const extAccepted = {
      image: ['gif', 'jpeg', 'jpg', 'png'],
      video: ['mp4', 'mov', 'avi', 'wmv', 'mkv', 'flv', 'webm'],
      document: ['pdf', 'csv', 'xlsx', 'xls', 'doc', 'docx', 'txt'],
    };

    // Defino la función para convertir los datos segun sea image, video o document.
    const conversionFunction = conversionFunctions[type_file];
    if (conversionFunction) {
      const filesFiltered = Array.from(e.target.files).filter(file => {
        const extName = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
        return extName && extAccepted[type_file].includes(extName);
      });

      setFileType(type_file);
      setIsMedia(true);
      const selectedFiles = [];
      let files = isPasteImg ? isPasteImg : filesFiltered;
      if(files.length > max_files){
        sendToast({type: "info", message: `La cantidad máxima de archivos permitida es: ${max_files}. Solo se adjuntaran los primeros ${max_files}`})
        
        const newArray = Object.fromEntries(
          Object.entries(files).slice(0, 6)
        );
        files = Object.values(newArray);
        // files = files.slice(0, max_files);
      }
      for (const file of files) {
        const base64 = await conversionFunction(file);
        if (base64) {
          selectedFiles.push({
            src: base64,
            name: file.name,
            size: `${((file.size * 1) / 1000000).toFixed(2)} MB`,
            file: file,
            type: type_file
          });
        }
      }
      setSelectedImg(selectedFiles[0].src);
      setDocumentView(selectedFiles[0])
      setSelectedFiles(selectedFiles);
      dataFilesRef.current = selectedFiles;
    }
  };

  const convertBase64 = (file) => {
    return new Promise((res, rej) => {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        res(fileReader.result);
      };
      fileReader.onerror = (error) => {
        rej(error);
      };
    });
  };

  const convertDocumentBase64 = (file) => {
    return new Promise((res, rej) => {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        res(fileReader.result);
      };
      fileReader.onerror = (error) => {
        rej(error);
      };
    });
  };

  const getSignedUrl = async (key_name, size) => {
    try {
      key_name = encodeURIComponent(key_name);
      const url = urlAPI_1 + `getSignedURL/${key_name}/${size}`;
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      if (response.status === 200) {
        const url_signed = await response.json();
        if (url_signed.error) {
          return false;
        }
        return url_signed;
      } else {
        console.error('Error getting signed URL');
        return false;
      }
    } catch (error) {
      console.error('Error getting signed URL:', error);
      return false;
    }
  };

  const uploadToS3 = async (file) => {
    try {
      console.log(file);
      const max_size = checkMaxSize(file.file);
      if (max_size) {
        return {error: true, description: "tam_limit_error", data: {name: file.name, size: file.size, file: file.file, type: file.type}};
      } else {
        const signedUrl = await getSignedUrl(file.name, file.file.size);
        console.log("signedUrl: ", signedUrl);
        if (signedUrl) {
          const url = await upload_s3 (file.file, signedUrl);
          return {error: false,  data: {url: url, name: file.name, size: file.size, file: file.file, type: file.type}};
        }
        return {error: true, description: "signed_url_error", data: {name: file.name, size: file.size, file: file.file, type: file.type}};
      }
    } catch (error) {
      console.error('Error uploading file...', error);
      return {error: true, description: "unknown_error", data: error, data: {name: file.name, size: file.size, file: file.file, type: file.type}};
    }
  };

  const checkMaxSize = (file) => {
    let max_size = false;
    if(file.type.includes("audio") && file.size > ((1024 * 1024) * 16)){
      max_size = true;
      sendToast({type: "info", message: `El archivo ${file.name} supera el peso máximo permitido para audio: 16MB. Intente enviarlo como documento una vez finalizado el proceso de carga.`})
    }
    if(file.type.includes("video") && file.size > ((1024 * 1024) * 16)){
      max_size = true;
      sendToast({type: "info", message: `El archivo ${file.name} supera el peso máximo permitido para video: 16MB. Intente enviarlo como documento una vez finalizado el proceso de carga.`})
    }
    if(file.type.includes("image") && file.size > ((1024 * 1024) * 5)){
      max_size = true;
      sendToast({type: "info", message: `El archivo ${file.name} supera el peso máximo permitido para imagen: 5MB. Intente enviarlo como documento una vez finalizado el proceso de carga.`})
    }
    if(file.type.includes("document") && file.size > ((1024 * 1024) * 100)){
      max_size = true;
      sendToast({type: "info", message: `El archivo ${file.name} supera el peso máximo permitido para documentos: 100MB. Intente enviarlo como documento una vez finalizado el proceso de carga.`})
    }
    return max_size;
  }

  const handleFileUpload = async (files) => {
    dataFilesRef.current = [];
    let results = {errors: 0, success: 0, error_size: 0, data_files: [], files_errors:[]};
    try {
      const uploadPromises = files.map(async file => {
        return await uploadToS3(file);
      });
      const uploadedUrls  = await Promise.all(uploadPromises);
      uploadedUrls.forEach((result) => {
        if(result.error){
          results.errors += 1;
          results.files_errors.push(result.data.file);
          if(result.description === "tam_limit_error"){
            results.error_size += 1;
          }
        }else{
          results.success += 1;
          results.data_files.push(result.data);
        }
      })
    } catch (error) {
      console.error('Error uploading files...', error);
    }
    return results;
  };

  //Evento para agregar emojis al chat
  const onEmojiClick = (event, emojiObject) => {
    setInputStr((prevInput) => prevInput + emojiObject.emoji);
    if (emojiObject) {
      inputRef.current.focus();
      setSelectedEmoji(true);
    }else{
      setSelectedEmoji(false);
    }
  };

  // Obtener lista de respuestas Rápidas
  const getQuickReply = async () => {
    try {
      const url = urlAPI_1 + "quicklyAnswers";
      const options = { method: "GET", mode: "cors"};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      if (result.code === 0) {
        sendToast(result)
        setQuicklyAnswers([]);
      } else if (result.data.length <= 0) {
        setQuicklyAnswers([]);
      } else {
        setQuicklyAnswers(result.data);
        setSearchQuicklyAnswer(result.data)
      }
    } catch (error) {
      console.log(error);
    }
  }

  // Pintar mensaje al estado de listMessages de forma síncrona
  function addMsgInListMessageSync(value) {
    value["agentAsign"] = conversation?.userAsign ?? "Sin asignar";
    value["botInfo"] = "";
    console.log("value in addMsgInListMessageSync📂📂📂", value);
    Promise.resolve().then(() => {
      console.log("Se va a actualizar listMessages: ", [value]);
      setListMessages((prevMessage) => prevMessage.concat([value]));
    });
  }

  // Reemplaza las variables de las plantillas
  const quickResponseVariables = () => {
    const labels = { email: "Correo", name: "Nombre", lastName: "Apellido", phone: "Celular" };
    const skip = ["company", "created", "lists", "tags", "_id"];
    return Object.entries(infoContact || {}).reduce((data, [key, value]) => {
      if (!skip.includes(key.toLowerCase()) && (typeof value === "string" || typeof value === "number")) data[labels[key] || key] = String(value);
      return data;
    }, {});
  };

  const markLastMessageAsFailed = (uniqueId) => {
    setListMessages((messages) => messages.map((row) => (row.reference && row.reference === uniqueId ? { ...row, status: "failed" } : row)));
  };

  const replaceQuickResponses = (text) => {
    const variablesQuickResponses = quickResponseVariables();
    const regex = /\{\{(.*?)\}\}/g;
    let textModified = text.replace(regex, (match, key) => {
      return variablesQuickResponses[key]?.trim() || '';
    });

    return textModified;
  }

  // Evento al presionar enter para enviar el mensaje
  const keyDown = (e) => {
    if (inputStr) {
      if (e.key === 'Enter' && e.shiftKey) {
        // Inserta un salto de línea
        const textarea = document.getElementById("myTextarea");
        textarea.value += '\n';
        textarea.style.height = "auto";
        e.preventDefault();
      } else if (e.keyCode === 13) {
        e.preventDefault();
        onSendMessage({});
        const textarea = document.getElementById("myTextarea");
        textarea.style.height = "auto";
      }
    }
  };

  // Enviar mensaje de texto
  const onSendMessage = async () => {
    const uniqueId = uuidv4();
    console.log('Enviando mensaje: ', inputStr)
    setShowPicker(false);
    setSelectedEmoji(false);
    setCloseEmojis(false);

    const {urlParam,urlParam2} = formSendTemplate.watch();
    const fieldsParams = formSendTemplate.watch();
    let textMedio = "";
    let arrFields = [];
    let idTemplateCopy = idTemplate;
    let objData = {};
    if( (templateSelected.length > 0 )) {
        console.log('🌞ES PLANTILLA🌞');
        console.log('🌞infoContact🌞: ', infoContact);
        console.log('conversation: ', conversation);
        setIsSendTemplate(false)
        // setLoading(true);
        // setLoadingSendTemplate(true);
        // En teoria habria solo un mensaje en dataFilesRef.current
        const filteredTemplates = templates.filter(tem => tem.id === idTemplateCopy);
        if(filteredTemplates.length){
        const filterBody = filteredTemplates[0].content.filter(tem => {if (tem.type === "BODY") return tem})
            if(filterBody.length){
                textMedio = filterBody[0].text;
                arrFields = textMedio.match(/{{\d+}}/g) || [];
                for (let i = 0; i < arrFields.length; i++) {
                  textMedio = textMedio.replace(arrFields[i], fieldsParams[`param${i}`])
                }
            }
        }
        console.log("::::::::::::::::::::dataFilesRef.current: ", dataFilesRef.current);
        console.log("::::::::::::::::::::dataFilesRef.current[0]: ", dataFilesRef.current[0]);
        console.log("::::::::::::::::::::dataFilesRef.current: ", dataFilesRef.current.length);
        if(dataFilesRef.current.length){
            dataFilesRef.current.forEach((data_media) => {
                let new_message = {};
                if(listMessages.length){
                    new_message = JSON.parse(JSON.stringify(listMessages[0]));
                }
                new_message["originMessage"] = "agent";
                new_message["bodytext"] = textMedio;
                new_message["bodyType"] = dataFilesRef.current[0].type;
                new_message["bodyMedia"] = dataFilesRef.current[0].url;
                new_message["nameMedia"] = dataFilesRef.current[0].name;
                new_message["messageId"] = "";
                new_message["idTemplate"] = idTemplateCopy;
                new_message["date"] = new Date();
                new_message["timestamp"] = Math.floor(new_message["date"].getTime());
                new_message["timestampInt"] = Math.floor(new_message["date"].getTime());
                new_message["status"] = "pending";
                new_message["reference"] = uniqueId;
                new_message["phoneNumber"] = conversation.phoneNumber;
                // new_message["phoneNumber"] = localStorage.getItem("CHAT_SELECTED");
                addMsgInListMessageSync(new_message);
            })
        }else{
            let new_message = {};
            if(listMessages.length){
                new_message = JSON.parse(JSON.stringify(listMessages[0]));
            }
            new_message["originMessage"] = "agent";
            new_message["bodytext"] = textMedio;
            new_message["bodyType"] = "template";
            new_message["bodyMedia"] = "";
            new_message["nameMedia"] = "";
            new_message["messageId"] = "";
            new_message["idTemplate"] = idTemplateCopy;
            new_message["date"] = new Date();
            new_message["timestamp"] = Math.floor(new_message["date"].getTime());
            new_message["timestampInt"] = Math.floor(new_message["date"].getTime());
            new_message["status"] = "pending";
            new_message["reference"] = uniqueId;
            new_message["phoneNumber"] = conversation?.phoneNumber ?? resolveInternationalPhone(infoContact.callingCode, infoContact.phone)
            // new_message["phoneNumber"] = localStorage.getItem("CHAT_SELECTED");
            addMsgInListMessageSync(new_message);
        }

        // Si hay archivos multimedia los subo a S3 y obtengo sus datos:
        let data_file = {};
        if(dataFilesRef.current.length > 0){
          // Primero subo los archivos a S3 y obtengo las urls.
          console.log("Subiendo archivos a S3 antes de enviar plantilla: ", dataFilesRef.current);
          let result_upload = await handleFileUpload(dataFilesRef.current);
          data_file = result_upload.data_files[0];          
          if(result_upload.errors){
            console.log("result_upload: ", result_upload);
            const newListMessages = listMessages.filter((message) => {
              return !result_upload.files_errors.some((fileError) => fileError.name === message.nameMedia);
            });

            Promise.resolve().then(() => {
              console.log("Se va a actualizar listMessages para eliminar archivos con error: ", newListMessages);
              setListMessages((prevMessage) => {return newListMessages});
              // setTimeout(() => {
              //   scrollToBottom("auto");
              // }, 100);
            });

          }
          

        }

        let objParamsBody = [];
        if (arrFields) {
          console.log('Fields: ', fieldsParams);
          for (let i = 0; i < arrFields.length; i++) {
            objParamsBody.push({type: "text", text: fieldsParams[`param${i}`], number: arrFields[i]})
          }
        }

        let objParamsMedia = {};
        if(fileType == "image" || fileType == "video" || fileType == "document"){
          console.log("data_file: ", data_file)
          let data_media = {urlFile: data_file.url, nameFile: data_file.name, sizeFile: data_file.file.size};
          console.log("data_media: ", data_media)
          if (fileType == "image") {
            objParamsMedia = { image: data_media };
          } else if (fileType == "video") {
            objParamsMedia = { video: data_media };
          } else if (fileType == "document") {
            objParamsMedia = {
              document: data_media,
            };
          }
        }

        let varUrl = "";
        if (isUrlDynamic) {
          varUrl = urlParam
        } else if (isUrlDynamic2) {
          varUrl = urlParam2
        }

        objData = {
            to: conversation?.phoneNumber ?? resolveInternationalPhone(infoContact.callingCode, infoContact.phone),
            user: nameConv,
            type: "template",
            template: {
                id: idTemplateCopy,
                parametersMedia: objParamsMedia,
                parametersBody: objParamsBody,
                parameterUrl: varUrl,
            },
        };
        objData.reference = uniqueId;
        let timestamp_schedule = "";
        if(messageScheduleDate){
          console.log('👉👉👉messageScheduleDate', messageScheduleDate);
          timestamp_schedule = new Date(messageScheduleDate).getTime().toString();
          console.log('👉👉👉timestamp_schedule', timestamp_schedule);
        }
        objData.messageScheduleDate = timestamp_schedule;
        console.log('--->OBJDATA:', objData)
    } else {
      var new_message = JSON.parse(JSON.stringify(listMessages[0]));
      new_message["originMessage"] = "agent";
      new_message["bodytext"] = inputStr;
      new_message["bodyType"] = "text";
      new_message["bodyMedia"] = "";
      new_message["messageId"] = "";
      new_message["date"] = new Date();
      new_message["timestamp"] = Math.floor(new_message["date"].getTime());
      new_message["timestampInt"] = Math.floor(new_message["date"].getTime());
      new_message["status"] = "pending";
      new_message["reference"] = uniqueId;
      addMsgInListMessageSync(new_message);
  
      objData = {
        to: conversation?.phoneNumber ?? resolveInternationalPhone(infoContact.callingCode, infoContact.phone),
        user: nameConv,
        type: "text",
        text: {
          body: inputStr,
        },
      };

      console.log('Mensaje escrito: ', objData);
      setInputStr("");
      setFileType((fileType) => { return "" });

    }
    
    scrollToBottom("auto");
    dataFilesRef.current = [];
    setTemplateSelected((templateSelected) => { return []})
    setTextDocument("");
    setIsMedia((isMedia) => { return false });
    setFileType((fileType) => { return "" });
    setSelectedFiles((prevMessage) => { return []})
    setIdTemplate((prevMessage) => { return ""});
    formSendTemplate.reset()
    // setFieldsParams({});


    const url = urlAPI_1 + "saveAgentMessages";
    const options = { method: "POST", mode: "cors", body: JSON.stringify(objData)};
    const response = await fetchWithAuth(url, options);
    const result = await response.json();
    console.log('-------result saveAgentMessages-------->', result)

    fetch_messages(conversation?.phoneNumber ?? resolveInternationalPhone(infoContact.callingCode, infoContact.phone), true);
  }

  //Funcion para enviar mensajes multimedia exclusivamente desde el boton importar. Soporta el envio múltiple.
  const onSendMessageMedia = async (idAnswer) => {
    // setViewAnswers(false);
    setShowPicker(false);
    setCloseEmojis(false);
    setSelectedEmoji(false);
    const uniqueId = uuidv4();
    //#------> Validamos si esta tratando de enviar un mensaje diferente a plantilla despues de 24 horas
    if (timerConectionChat >= 24) {
      if(listMessages.length && templateSelected.length == 0){
        let new_message = JSON.parse(JSON.stringify(listMessages[0]));
        new_message["originMessage"] = "agent";
        new_message["bodytext"] = "⚠️Recuerda que por políticas de META es necesaria una respuesta del contacto para poder continuar la conversación.⚠️";
        new_message["bodyType"] = "warning";
        new_message["bodyMedia"] = "";
        new_message["nameMedia"] = "";
        new_message["messageId"] = "";
        new_message["idTemplate"] = "";
        new_message["date"] = new Date();
        new_message["timestamp"] = Math.floor(new_message["date"].getTime());
        new_message["timestampInt"] = Math.floor(new_message["date"].getTime());
        new_message["status"] = "pending";
        new_message["reference"] = uniqueId;

        addMsgInListMessageSync(new_message);

        scrollToBottom("auto");
        setSelectedFiles((prevMessage) => { return []})
        setTextDocument("");
        setIsMedia((isMedia) => { return false });
        setFileType((fileType) => { return "" });
      }

    } else {
      // Me copio los valores por si durante la funcion cambia debido a interacciones del usuario con el front.
      let textDocumentCopy = replaceQuickResponses(textDocument);
      let phoneCopy = conversation.phoneNumber;
      let contactNameCopy = conversation.user;
      let isConv = false;
      if (idAnswer) {
        setIsMedia((isMedia) => { return false });
        setIsMediaAnswer((isMediaAnswer) => { return "" });
        setIsMediaTypeAnswer((isMediaTypeAnswer) => { return "" });
        setIdAnswerSelected((isAnswerSelected) => { return "" });

        const ansFilter = quicklyAnswers.filter(quickly => quickly._id == idAnswer)
        console.log('Respuesta rapida seleccionada==>', ansFilter)
        const {content, mediaType, media, mediaName} = ansFilter[0];
        let objData = {}
        if (mediaType == "image") {
          objData = {
              to: phoneCopy,
              user: contactNameCopy,
              nameMedia: mediaName,
              type: "image",
              url: media,
              fileText: textDocumentCopy
            };
        } else {
          objData = {
            to: phoneCopy,
            user: contactNameCopy,
            nameMedia: mediaName,
            type: "document",
            url: media,
            fileText: textDocumentCopy
          };
        }
        if(listMessages.length){
          let typeMedia = ""
          if(mediaType === "pdf") {
            typeMedia = "document"
          } else {
            typeMedia = "image"
          }
          var new_message = JSON.parse(JSON.stringify(listMessages[0]));
          new_message["originMessage"] = "agent";
          new_message["bodytext"] = textDocumentCopy;
          new_message["bodyType"] = typeMedia;
          new_message["bodyMedia"] = media;
          new_message["nameMedia"] = mediaName;
          new_message["messageId"] = "";
          new_message["date"] = new Date();
          new_message["timestamp"] = Math.floor(new_message["date"].getTime());
          new_message["timestampInt"] = Math.floor(new_message["date"].getTime());
          new_message["status"] = "pending";
          new_message["reference"] = uniqueId;
          addMsgInListMessageSync(new_message);
        }
        objData.reference = uniqueId;
        scrollToBottom("auto");
        console.log('✅✅✅',objData);
        try {
          const url = urlAPI_1 + "saveAgentMessages";
          const options = { method: "POST", mode: "cors", body: JSON.stringify(objData)};
          const response = await fetchWithAuth(url, options);
          const result = await response.json();
          scrollToBottom("auto");

          if (result.type === "info") {
            console.log('Desde el envio de medios.............')
            showToast(result)
          } else if (result.type === "error") {
            markLastMessageAsFailed(uniqueId);
          }

          if (result.isConv) {
            isConv = true;
          }
        } catch (error) {
          console.log(error);
        }

      } else {
        // Envio los mensajes al chat inmediatamente, sin enviar por Whatsaap.
        // Valido si todos los archivos son image: 
        let all_images = true;
        dataFilesRef.current.forEach((data_media) => {
          if(data_media.type != "image"){
            all_images = false;
          }
        });
        if (dataFilesRef.current.length >= 2 && all_images) {
          if (listMessages.length) {
            let arrayImgs = []
            for (let img of dataFilesRef.current) {
              arrayImgs.push(img.src)
            }
            let new_message = JSON.parse(JSON.stringify(listMessages[0]));
            new_message["originMessage"] = "agent";
            new_message["bodytext"] = textDocumentCopy;
            new_message["bodyType"] = "groupedImages";
            new_message["bodyMedia"] = arrayImgs;
            new_message["nameMedia"] = "";
            new_message["messageId"] = "";
            new_message["idTemplate"] = "";
            new_message["date"] = new Date();
            new_message["timestamp"] = Math.floor(new_message["date"].getTime());
            new_message["timestampInt"] = Math.floor(new_message["date"].getTime());
            new_message["status"] = "pending";
            new_message["reference"] = uniqueId;
            addMsgInListMessageSync(new_message);
          }
        } else {
          dataFilesRef.current.forEach((data_media) => {
            if (listMessages.length) {
              let new_message = JSON.parse(JSON.stringify(listMessages[0]));
              new_message["originMessage"] = "agent";
              new_message["bodytext"] = textDocumentCopy;
              new_message["bodyType"] = data_media.type;
              new_message["bodyMedia"] = data_media.src;
              new_message["nameMedia"] = data_media.name;
              new_message["messageId"] = "";
              new_message["idTemplate"] = "";
              new_message["date"] = new Date();
              new_message["timestamp"] = Math.floor(new_message["date"].getTime());
              new_message["timestampInt"] = Math.floor(new_message["date"].getTime());
              new_message["status"] = "pending";
              new_message["reference"] = uniqueId;
              addMsgInListMessageSync(new_message);
            }
          })
        }
        setSelectedFiles((prevMessage) => { return []})
        setTextDocument("");
        setIsMedia((isMedia) => { return false });
        setFileType((fileType) => { return "" });
        // Envio los mensajes por whatsapp.
        // Primero subo los archivos a S3 y obtengo las urls.
        let result_upload = await handleFileUpload(dataFilesRef.current);
        // Ahora sí los envio por whatsapp.
        // Reemplazo new_message["bodyMedia"] por las urls nuevas. 
        // await replaceMediaFiles(result_upload.data_files, phoneCopy, uniqueId);

        if(result_upload.errors){
          const newListMessages = listMessages.filter((message) => {
            return !result_upload.files_errors.some((fileError) => fileError.name === message.nameMedia);
          });

          Promise.resolve().then(() => {
            console.log("Se va a actualizar listMessages para eliminar archivos con error: ", newListMessages);
            setListMessages((prevMessage) => {return newListMessages});
            setTimeout(() => {
              scrollToBottom("auto");
            }, 100);
          });

        }
        
        const uploadPromises = result_upload.data_files.map(async (data_media) => {
          const objData = {
            to: phoneCopy,
            user: contactNameCopy,
            nameMedia: data_media.name,
            type: data_media.type,
            url: data_media.url,
            fileText: textDocumentCopy,
          };
          objData.reference = uniqueId;
          try {
            const url = urlAPI_1 + "saveAgentMessages";
            const options = { method: "POST", mode: "cors", body: JSON.stringify(objData)};
            const response = await fetchWithAuth(url, options);
            const result = await response.json();
            scrollToBottom("auto");

            if (result.type === "info") {
              console.log('Desde el envio de medios.............')
              showToast(result)
            } else if (result.type === "error") {
              markLastMessageAsFailed(uniqueId);
            }
            if (result.isConv) {
              isConv = true;
            }
          } catch (error) {
            console.log(error);
          }
        });

        // Esperar a que todas las promesas se resuelvan
        try {
          await Promise.all(uploadPromises);
        } catch (error) {
          console.log("Error in uploadPromises:", error);
        }
      }
    }

    scrollToBottom("auto");
    fetch_messages(conversation.phoneNumber, true);
  };

  const replaceMediaFiles = async (data, phoneNumber, reference) => {
    let array__media_urls = [];
    for(let file of data){
      array__media_urls.push(file.url);
    }
    if(array__media_urls.length == 0){
      return;
    }
    
    if(array__media_urls.length == 1){
      array__media_urls = array__media_urls[0];
    }

    let aux = listUserChatsRef.current.filter(row => row.phoneNumber.slice(-10) == phoneNumber.slice(-10));
    if(!aux.length){
        return;
    }

    let messages = [];
    aux[0].messagesList.forEach((msg) => {
        if(msg.reference === reference){
            msg.bodyMedia = array__media_urls;
        }
        messages.push(msg);
    });

    // let current_number = localStorage.getItem("CHAT_SELECTED");
    // if(current_number.slice(-10) == phoneNumber.slice(-10)){
    //   setListMessages((prevMessage) => { return messages });
    // }
  }

  const onChatStatus = async (e, checkForTabSwitchControl = true) => {
    console.log('👉👉status: ', e);

    const userLogout = localStorage.getItem("USER_NAME");
    var objFinal = {
      chatStatus: e,
      user: userLogout
    };
    let phoneConv = resolveInternationalPhone(infoContact.callingCode, infoContact.phone)
    console.log("📞PHONE: ", phoneConv);
    if (phoneConv.includes("+")) {
      const cod = infoContact.callingCode.replace("+", "");
      phoneConv = cod+infoContact.phone;
    }
    try {
      const url = urlAPI_1 + "assignChat/" + phoneConv;
      const options = { method: "POST", mode: "cors", body: JSON.stringify(objFinal)};
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log('👉👉result chat status: ', result);
      
    } catch (error) {
      console.log(error);
    }
  };

  const onAssignAgent = async (id, name, take_by_self=true) => {
    console.log("..Ejecutando onAssignAgent..");
    // console.log("filterRef.current: ", filterRef.current);
    const {contentNote} = watch()
    const conv = localStorage.getItem("CONVERSATION_SELECTED")
    console.log("CONV: ", conv);
    var objFinal = {
      agentId: id,
      chatId: localStorage.getItem("CONVERSATION_SELECTED"),
      transferNote: "",
      // transferNote: contentNote,
      agentAssigned: agentAssigned.current,
    };
    console.log("objFinal: ", objFinal);
    let phoneConv = resolveInternationalPhone(infoContact.callingCode, infoContact.phone)
    console.log("📞PHONE: ", phoneConv);
    if (phoneConv.includes("+")) {
      const cod = infoContact.callingCode.replace("+", "");
      phoneConv = cod+infoContact.phone;
    }
    console.log("📞📞PHONE: ", phoneConv);
    try {
      setLoading(true);
      const url = urlAPI_1 + "assignChat/" + phoneConv;
      const options = { method: "POST", mode: "cors", body: JSON.stringify(objFinal)};
      const response = await fetchWithAuth(url, options);
      agentAssigned.current = true;
      const result = await response.json();
      //updateConversations();
      if (result.type === "error") {
        sendToast(result)
      }else{
        // INICIO: Abrimos la conversación de forma inmediata
        // Solo cuando aprieta "Tomar conversación"
        await onChatStatus("1", false);
        // FIN: Abrimos la conversación de forma inmediata 
        setIsAssignedAgent(false);
        fetch_messages(phoneConv, true);
      }
      
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    setListPersons(persons);
  }, [persons])

  return (
    <Fragment>
      {loading ? (
        <div className="content-spinner">
          <Spinner />
        </div>
      ) : null}

      <style>{BOT_LIST_CSS}</style>
      <style>{PROSPECTS_CSS}</style>
      <div ref={rootRef} className="su-kit su-list-root pz-root" style={{ height: rootHeight ? `${rootHeight}px` : undefined }}>
          <div className="pz-main" style={{width: showContactInfo || showContacts ? "75%" : "100%"}}>
            <ProspectsHeader
              mode={mode}
              setMode={setMode}
              stagesCount={listStages.filter((stage) => !stage.new).length}
              prospectsCount={listStages.reduce((total, stage) => total + (stage.prospects || []).filter(Boolean).length, 0)}
              onAutomatic={() => setModalConfig(true)}
            />
            <div className="pz-body">
            {mode == "process" ? (
              <Process
                isColumnDragDisabled={isColumnDragDisabled}
                listStages={listStages}
                handleContactInfo={handleContactInfo}
                setNameConv={setNameConv}
                setActiveId={setActiveId}
                fetch_messages={fetch_messages}
                setInfoContact={setInfoContact}
                setShowContacts={setShowContacts}
                setShowContactInfo={setShowContactInfo}
                setStageSelected={setStageSelected}
                onDragStart={onDragStart}
                onDragEnd={onDragEnd}
                onAddStage={() => createStage()}
                onStageAction={handleStageAction}
              />
            ):( 
              <ModeTable
                listStages={listStages}
                setShowContactInfo={setShowContactInfo}
                setShowContacts={setShowContacts}
                setDataContactInfo={setDataContactInfo}
                validation={validation}
              />
            )}
            </div>
          </div>

          {showContactInfo && (
            <ContactInfo 
              dataContactInfo={dataContactInfo} 
              setShowContactInfo={setShowContactInfo} 
              setDataContactInfo={setDataContactInfo} 
              allLists={allLists} 
              handleChangeList={handleChangeList} 
              addUserToList={addUserToList} 
              isDisableSelect={isDisableSelect} 
              customStyles={customStyles} 
              customStylesDark={customStylesDark} 
              isDark={isDark}  
              Botton={Botton}
              Icon={Icon}
              Avvvatars={Avvvatars}
              Alert={Alert} 
              ordersFilteredInfo={ordersFilteredInfo} 
              formPutPerson={formPutPerson} 
              error8={error8} 
              sendToast={sendToast} 
              fieldsList={fieldsList} 
              setLoading={setLoading}
              reloadDataContact={reloadDataContact}
              contactStage={contactStage}
              reset={reset}
              addNewSegment={addNewSegment}
              setAddNewSegment={setAddNewSegment}
              setIsDisableSelect={setIsDisableSelect}
            />
          )}

          {showContacts && (
            <ContactList
              Botton={Botton}
              setShowContacts={setShowContacts}
              stageSelected={stageSelected}
              searchQuery={searchQuery}
              onSearchPersons={onSearchPersons}
              loadingContacts={loadingContacts}
              setListPersons={setListPersons}
              listPersons={listPersons}
              getStages={getStages}
              setStageSelected={setStageSelected}
              setLoading={setLoading}
              Alert={Alert}
              correspondence={correspondence}
              listTags={listTags}
              setLoadingContacts={setLoadingContacts}
              searchTerm={searchTerm}
            />
          )}
      </div>

      <Tooltip id="my-tooltip" style={{ zIndex: 9999, backgroundColor: "black", color: "white", padding: "5px 10px", borderRadius: "5px", whiteSpace: "pre-line", maxWidth: "500px" }} />

      {/* Modal para enviar mensajes */}
      <Modal
        status={activeId}
        changeStatus={setActiveId}
        title= {conversation ? "Enviar mensaje a " + nameConv : "Crear conversación con " + nameConv}
        width={"900px"}
        // width={conversation && conversation.timerConection > 24 ? "1100px" : "700px"}
        padding="20px 0px 0px 0px"
        button={loadingConv ? false : true}
        nameAsigned={infoAsigned || ""}
      >
        <Content className="flex-column align-items-center"  style={contentStyle}>
          {loadingConv ? (
            <span className="d-flex" style={{ marginLeft: "7px", marginBottom: "10px" }}>
              <FaSpinner
                className="fa-spin"
                style={{ fontSize: "25px", color:"#5bc0de" }}
              />
            </span>
          ) : (
            isSendTemplate ? (
              <SendMessage 
                contactName={nameConv}
                templates={templates}
                isDark={isDark}
                conversation={conversation}
                setActiveId={setActiveId}
                nameConv={nameConv}
                listMessages={listMessages}
                addMsgInListMessageSync={addMsgInListMessageSync}
                onSendMessage={onSendMessage}
                setIdTemplate={setIdTemplate}
                idTemplate={idTemplate}
                setTemplateSelected={setTemplateSelected}
                templateSelected={templateSelected}
                setIsSendTemplate={setIsSendTemplate}
                setMessageScheduleDate={setMessageScheduleDate}
                messageScheduleDate={messageScheduleDate}
                setSelectedFiles={setSelectedFiles}
                selectedFiles={selectedFiles}
                convertBase64 = {convertBase64}
                convertDocumentBase64={convertDocumentBase64}
                setSelectedImg = {setSelectedImg}
                setDocumentView = {setDocumentView}
                dataFilesRef = {dataFilesRef}
                setIsUrlDynamic = {setIsUrlDynamic}
                setIsUrlDynamic2 = {setIsUrlDynamic2}
                setFileType = {setFileType}
                fileType = {fileType}
                formSendTemplate = {formSendTemplate}
                error1 = {error1}
              />
            ) : (

              isMedia ? (
                <PreviewMediaToSend 
                  isMediaAnswer = {isMediaAnswer}
                  isMediaTypeAnswer = {isMediaTypeAnswer}
                  selectedImg = {selectedImg}
                  fileType = {fileType}
                  documentView = {documentView}
                  mediaSelected = {mediaSelected}
                  selectedFiles = {selectedFiles}
                  textDocument = {textDocument}
                  inputRef = {inputRef}
                  idAnswerSelected = {idAnswerSelected}
                  setSelectedImg = {setSelectedImg}
                  setMediaSelected = {setMediaSelected}
                  setTextDocument = {setTextDocument}
                  setIsMedia = {setIsMedia}
                  setFileType = {setFileType}
                  setDocumentView = {setDocumentView}
                  setContenMessage = {setContenMessage}
                  setSelectedFiles = {setSelectedFiles}
                  dataFilesRef = {dataFilesRef}
                  focusLastMessage = {scrollToBottom}
                  handleRemoveFile = {handleRemoveFile}
                  keyDown = {keyDown}
                  onSendMessageMedia = {onSendMessageMedia}
                />
              ) : (
                <>
                  <div 
                    className="btn-panel d-flex align-items-center justify-content-center" 
                    style={{
                      width: "100%",
                      borderRadius: "0px",
                      position: "relative",
                    }}
                    onClick={() => {
                        navigate(`/home/chat`, { 
                            state: { 
                                parametro: resolveInternationalPhone(infoContact.callingCode, infoContact.phone),
                                idContact: infoContact._id,
                                isChat: true
                            } 
                        })
                    }}
                  >
                    <span className="mr-2">Ir al panel multiagente</span>
                    <FaShareFromSquare />
                  </div>

                  <div style={{height: "95%", width: "100%", position: "relative", borderRadius: "0px 0px 12px 12px"}} id="content-message-all">
                    <MessageList
                      listMessages={listMessages}
                      // listMessages={conversation.messagesList}
                      templates={templates}
                      showContactInfo={showContactInfo}
                      setListMessages={setListMessages}
                      infoContact={infoContact}
                      isProspects={true}
                    />

                    <span 
                      style={{
                          position:"absolute",
                          top: "5px",
                          left: "50%",
                          cursor: "pointer",
                          fontSize: "1.3rem",
                          color: "#FFF",
                          boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
                          display: "flex",
                          padding: "6px",
                          backgroundColor: "#5bc0de",
                          borderRadius: "50%"
                      }} 
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content="Actualizar mensajes."
                      onClick={() => {
                          fetch_messages(resolveInternationalPhone(infoContact.callingCode, infoContact.phone))
                      }}
                    >
                        <TfiReload />
                    </span>
                    
                    <div ref={chatEndRef}></div>
                    <div 
                        id="footer-chat" 
                        className={"content-btn-status d-flex px-2"} 
                        style={{
                          minHeight: "56px",
                          position: "absolute",
                          margin: "0 auto",
                          alignSelf: "center",
                          boxSizing: "border-box",
                          width: "98%",
                          zIndex: "1",
                          borderRadius: "40px",
                          alignItems: "center",
                          justifyContent: "between",
                          bottom: "5px",
                          left: "6px",
                          justifyContent: "center"
                        }}      
                      >
                        {isAssignedAgent ? (
                          <AssignConversationMessage
                            roleId = "123"
                            agentAssigned = {agentAssigned}
                            setModalTransferAgent = {setModalTransferAgent}
                            onAssignAgent = {onAssignAgent}
                          />
                        ) : (
                          conversation && conversation.timerConection > 24 ? (
                            <div 
                              id="is-send-template-btn" 
                              className="content-btn-send-template d-flex px-3 justify-content-center align-items-center text-center" 
                              style={{ height: "8%", marginBottom: "6px" }}
                            >
                              <MessageSendTemplate 
                                showContactInfo = {showContactInfo}
                                isProspects = {true}
                                setIsSendTemplate={setIsSendTemplate}
                              />
                            </div>
                            
                          ) : (
  
                            <>
                              {closeEmojis && (
                                <IoClose
                                  className="icon-cancel ml-1 d-flex pointer"
                                  style={{
                                    fontSize: "2rem",
                                    alignItems: "center",
                                    zIndex: "999"
                                  }}
                                  onClick={() => {
                                    setShowPicker((val) => !val);
                                    setCloseEmojis(false);
                                  }}
                                />
                              )}
                              <FaRegFaceLaugh id="emojis-chat" className={showPicker ? "icon-smile icon-chat active d-flex mx-1" : "icon-smile icon-chat d-flex mx-1"}
                                style={{ fontSize: "28px", alignItems: "center", zIndex: "998" }}
                                onClick={() => {
                                  setShowPicker((val) => !val);
                                  if (closeEmojis) {
                                    setCloseEmojis(false);
                                  } else {
                                    setCloseEmojis(true);
                                  }
                                }}
                                data-tooltip-id="my-tooltip" 
                                data-tooltip-content="Enviar emojis"
                              />
                              {/* Mostrar lista de emojis */}
                              {showPicker && (
                                <Picker
                                  pickerStyle={{
                                    width: "100%",
                                    left: "0px",
                                    position: "absolute",
                                    zIndex: "1",
                                    bottom: "4.9em",
                                  }}
                                  onEmojiClick={onEmojiClick}
                                  groupNames={{
                                    smileys_people: "Emoticones y personas",
                                    animals_nature: "Animales y naturaleza",
                                    food_drink: "Alimentos y bebidas",
                                    travel_places: "Viajes y lugares",
                                    activities: "Actividades",
                                    objects: "Objetos",
                                    symbols: "Símbolos",
                                    flags: "Banderas",
                                    recently_used: "Recientes",
                                  }}
                                />
                              )}
            
                              {/* Mostrar opciones de envios */}
                              <OptionsShippigProspects 
                                onFileInput = {onFileInput}
                                isComponentProspects = {true}
                                templates = {templates}
                                conversation = {conversation}
                                setActiveId = {setActiveId}
                                nameConv = {nameConv}
                                listMessages = {listMessages}
                                addMsgInListMessageSync = {addMsgInListMessageSync}
                                setIsSendTemplate = {setIsSendTemplate}
                              />
                              <TextareaSendMessage 
                                inputStr = {inputStr}
                                inputRef = {inputRef}
                                searchQuicklyAnswer = {searchQuicklyAnswer}
                                setContenMessage = {setContenMessage}
                                setInputStr = {setInputStr}
                                setViewAnswer = {setViewAnswer}
                                setQuicklyAnswers = {setQuicklyAnswers}
                                keyDown = {keyDown}
                                msgIA = {msgIA}
                                setMsgIA = {setMsgIA}
                                showTooltip = {showTooltip}
                              />
                              {/* Mostrra lista de respuestas rápidas al escribir / en el input */}
                              {viewAnswer && (
                                <QuickAnswerList 
                                  quicklyAnswers = {quicklyAnswers}
                                  setIsMedia = {setIsMedia}
                                  setIsMediaAnswer = {setIsMediaAnswer}
                                  setIsMediaTypeAnswer = {setIsMediaTypeAnswer}
                                  setTextDocument = {setTextDocument}
                                  setViewAnswer = {setViewAnswer}
                                  setInputStr = {setInputStr}
                                  setIdAnswerSelected = {setIdAnswerSelected}
                                  inputRef = {inputRef}
                                  getQuickReply = {getQuickReply}
                                  isProspects = {true}
                                />
                              )}
            
                              <span 
                                className='d-flex ml-2 w-auto' 
                                style={{
                                  backgroundColor:"#25d366", 
                                  padding:"8px 6px 8px 11px", 
                                  borderRadius:"50%", 
                                  zIndex: "9"
                                }}
                              >
                                <IoMdSend 
                                  id='icon-send-messages' 
                                  className="send pointer" 
                                  style={{ fontSize: "27px" }}
                                  onClick={() => onSendMessage({})}
                                />
                              </span>
                            </>
  
                          )
                        )}

    
                    </div>
                  </div>
                </>

              )
            )
          )}


        </Content>

      </Modal>

      {/* Modal para mostrar configuraciones */}
      <Modal
        status={modalConfig}
        changeStatus={setModalConfig}
        title= "Agregar automaticamente propectos a estapa"
        width={"600px"}
      >
        <Content>
          <form style={{ width: "100%" }} onSubmit={formAutomatic.handleSubmit(saveAutomatic)}>
            <div className="su-control mt-2">
              <div className="d-flex justify-content-center align-items-center">
                <label className="mr-2">¿Deseas activar el guardado automatico?: </label>
                <input
                  name="transfer"
                  id="automaticActiveId"
                  type="checkbox"
                  className="cmn-toggle cmn-toggle-round-flat"
                  checked={automaticCheck}
                  onChange={(e) => setAutomaticCheck(e.target.checked)}
                />
                <label className="m-0" htmlFor="automaticActiveId"></label>
              </div>
              {automaticCheck && (
                <div className="mt-3">
                  <label>Selecciona la etapa: </label>
                  <p style={{fontSize: "1em", fontStyle: "italic"}}>La etapa que selecciones, sera a la que se guardaran todos los contactos que escriban por primera vez a tu cuenta.</p>
                  <div className="su-control-group">
                    <select
                      className="form-control mb-1"
                      {...formAutomatic.register("stage", {
                        required: {
                          value: true,
                          message:"Debes seleccionar una etapa.",
                        },
                      })}
                    >
                      <option value="" key="0" disabled selected={automaticCheck ? true : false}>Seleccione...</option>
                      {listStages.length !== 0 && listStages.map((stage, i)=>(
                        <option key={i} value={stage._id} selected={automaticCheck && stage._id === savedStage ? true : false}>{stage.name}</option>
                      ))}
                    </select>
                    {error9.stage && <Alert>* {error9.stage.message}</Alert>}
                  </div>
                </div>
              )}
            </div>

            <div className="row justify-content-end bd col-12 mt-4 ml-1">
              <a
                href="javascript:;"
                className="btn btn-lg btn-default mr-1"
                onClick={() => {
                  setModalConfig((prevMessage) => { return false});
                }}
              >
                Cancelar
              </a>
              
              <input
                className="btn btn-lg btn-info"
                type="submit"
                value="Guardar"
                // onClick={() => window.location.href = "/#/home/paymentMethods"}
              />
            </div>
          </form>


        </Content>
      </Modal>

      <ConfirmDialog confirm={confirmStage} onClose={closeConfirmStage} />

      <Toaster containerClassName="su-toasts" />

    </Fragment>
  );
};


export default Prospects;

const Botton = styled.button`
  color: #000000;
  background: transparent;
  border: none;
  cursor: pointer;
  opacity: 0.3;

  &:hover {
    color: #000000;
    opacity: 0.7;
  }
`;
const Icon = styled.div`
  margin-bottom: 20px;

  div {
    height: 120px;
    width: 120px;
    border-radius: 50%;
    // box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.7);
    margin: 0 auto;
  }

  p {
    font-size: 40px;
    font-weight: 600;
  }
`;
const Alert = styled.span`
  color: red;
  display: block;
  width: 200px;
  font-size: 0.8rem;
`;
const Content = styled.div`
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  h1 {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 10px;
    text-align: center;
  }
  li {
    padding: 10px 5px;
    border-bottom: 1px solid rgb(0, 0, 0, 0.05);
  }
  li:hover {
    background: rgb(0, 0, 0, 0.05);
  }
  p {
    font-size: 18px;
    margin-bottom: 0px;
  }
  input {
    padding: 10px;
    border-radius: 0px;
    font-size: 17px;
  }
  img.img-answer {
    cursor: pointer;
    width: auto;
    height: 85px;
    object-fit: scale-down;
  }
  .content-img {
    position: relative;
  }
  .content-img img:hover {
    opacity: 0.6;
  }
`;
const ModalContent = styled.div`
  overflow: auto;
  height: 335px;

  .checkbox {
    padding: 25px;
    width: 25px;
    height: 25px;
  }
`;
